
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { ProcurementFormValues } from "../schema";

interface AdvancePaymentSectionProps {
  form: UseFormReturn<ProcurementFormValues>;
  hasAdvancePayment: boolean;
  advancePaymentAmount: number;
  totalAmount: number;
}

export const AdvancePaymentSection = ({ 
  form, 
  hasAdvancePayment, 
  advancePaymentAmount, 
  totalAmount 
}: AdvancePaymentSectionProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="has_advance_payment"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Advance Payment</FormLabel>
              <FormDescription>
                Enable advance payment with fixed amount
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {hasAdvancePayment && (
        <div className="space-y-4 border-l-4 border-blue-200 pl-4">
          <FormField
            control={form.control}
            name="advance_payment_amount"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Advance Payment Amount (Br)</FormLabel>
                <FormDescription>
                  Fixed amount to be paid in advance (Total available: Br {totalAmount.toFixed(2)})
                </FormDescription>
                <FormControl>
                  <Input
                    type="number"
                    min="0"
                    max={totalAmount}
                    step="0.01"
                    {...field}
                    onChange={e => field.onChange(parseFloat(e.target.value) || 0)}
                  />
                </FormControl>
                <FormMessage />
                {advancePaymentAmount > totalAmount && (
                  <p className="text-sm text-destructive">
                    Advance payment cannot exceed total amount of Br {totalAmount.toFixed(2)}
                  </p>
                )}
              </FormItem>
            )}
          />

          {advancePaymentAmount > 0 && totalAmount > 0 && (
            <div className="bg-blue-50 p-3 rounded-md">
              <div className="text-sm space-y-1">
                <div className="flex justify-between">
                  <span>Total Amount:</span>
                  <span className="font-medium">Br {totalAmount.toFixed(2)}</span>
                </div>
                <div className="flex justify-between">
                  <span>Advance Payment:</span>
                  <span className="font-medium text-blue-600">Br {advancePaymentAmount.toFixed(2)}</span>
                </div>
                <div className="flex justify-between border-t pt-1">
                  <span>Remaining Amount:</span>
                  <span className="font-medium">Br {(totalAmount - advancePaymentAmount).toFixed(2)}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
